import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import BaseUrl from '../../base-api';
import moment from 'moment/moment';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

const LearnerDetails = () => {
    const [applications, setApplications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [pageSize] = useState(10);
    const [focusAfterClose, setFocusAfterClose] = useState(true);
    const [open, setOpen] = useState(false);
    const [user, setUser] = useState('');

    const [downloadingCode, setDownloadingCode] = useState(null);

    const [learnerDetails, setLearnerDetails] = useState({ "learnerCode": '', "uname": '', "pwd": '', "candidateCode": '', "pwd2": '',"course":'' });

    useEffect(() => {
        

        fetchApplications();
    }, [currentPage, pageSize]);
    const fetchApplications = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${BaseUrl}/app/fetchLearnerDetails`, {
                headers: {
                    Authorization: localStorage.getItem("$3ingT0k3n"),
                },
                params: {
                    page: currentPage,
                    size: pageSize,
                },
            });
            setApplications(response.data.content);
            setTotalPages(response.data.totalPages);
        } catch (error) {
            setError('Failed to fetch data');
        } finally {
            setLoading(false);
        }
    };
    const handlePageChange = (direction) => {
        setCurrentPage(prevPage => {
            if (direction === 'next' && prevPage < totalPages - 1) {
                return prevPage + 1;
            } else if (direction === 'prev' && prevPage > 0) {
                return prevPage - 1;
            }
            return prevPage;
        });
    };
    const handleLearnerDetailsChange = (event) => {
        const { name, value } = event.target;
        setLearnerDetails({ ...learnerDetails, [name]: value });
    };
    const showLearnerModal = (e) => {
        setLearnerDetails({ ...learnerDetails, "candidateCode": e.candidateCode,"course":e.course });
        setOpen(!open);
    }
    const closeLearnerModal = () => {
        setUser('');
        setOpen(!open);
        setLearnerDetails({ "learnerCode": '', "uname": '', "pwd": '', "candidateCode": '', "pwd2": '',"course":'' });
    }
    const submitLearnerDetails = async () => {
        try {
            const response = await axios.post(`${BaseUrl}/app/saveLearnerDetails`, learnerDetails, {
                headers: {
                    Authorization: localStorage.getItem("$3ingT0k3n"),
                },
            });
            if(response.status === 200){
                toast.success(response.data)
                fetchApplications();
                setOpen(!open);
            }
        } catch (error) {
            toast.error(error.response.data)
        }
    }
    const validateLearnerDetails = () => {
        if (!Object.values(learnerDetails).every(value => value)) {
            toast.error("Kindly fill all the required details.");
        } else if (learnerDetails.pwd !== learnerDetails.pwd2) {
            toast.error("Passwords not match.");
        } else {
            submitLearnerDetails();
        }
    }
    const sanitizeFileName = (name) =>
        (name || 'learner').trim().replace(/[^a-zA-Z0-9._-]/g, '_').replace(/_+/g, '_');

    const downloadLearnerDocuments = async (app) => {
        if (!app.learnerCode) {
            toast.error("Learner code is not available yet.");
            return;
        }
        try {
            setDownloadingCode(app.learnerCode);
            const response = await axios.get(`${BaseUrl}/app/downloadLearnerDocuments`, {
                headers: {
                    Authorization: localStorage.getItem("$3ingT0k3n"),
                },
                params: {
                    learnerCode: app.learnerCode,
                    learnerName: app.applicantName,
                },
                responseType: "blob",
            });

            const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${app.learnerCode}_${sanitizeFileName(app.applicantName)}_photo.jpg`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            toast.error("Failed to download photograph");
        } finally {
            setDownloadingCode(null);
        }
    }
    if (loading) return <p>Loading...</p>;
    if (error) return <p>{error}</p>;

    return (
        <div className="table-container">
            <h2 className='mt-2 mx-2'>Learner Details</h2>
            <table id="learnerDetails" className='mt-2 mx-2' >
                <thead>
                    <tr>
                        <th>Sr. No.</th>
                        <th>Learner Name</th>
                        <th>Mobile Number</th>
                        <th>Date of Birth</th>
                        <th>Enrolled Course</th>
                        <th>Is GJU Employee?</th>
                        <th>Enrolled On</th>
                        <th style={{width:"20px"}}>Learner Code</th>
                        <th>Documents</th>
                    </tr>
                </thead>
                <tbody>
                    {applications.map((app, index) => (
                        <tr key={index}>
                            <td>{index + 1 + (currentPage * pageSize)}</td>
                            <td>{app.applicantName}<br/><b> S/D/o</b> {app.fatherName}</td>
                            <td>{app.mobileNumber}</td>
                            <td>{moment(app.dob).format('DD/MM/YYYY')}</td>
                            <td>{app.course}</td>
                            <td>{app.employee ? "Yes" : "No"}</td>
                            <td>{app.enrolledOn}</td>
                            <td>{app.learnerCode ? app.learnerCode : <button type="button" className='btn btn-sm btn-primary' onClick={(e) => showLearnerModal(app)}>Add Details</button>}</td>
                            <td>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-secondary py-0 px-1"
                                    style={{ fontSize: '0.75rem' }}
                                    disabled={!app.learnerCode || downloadingCode === app.learnerCode}
                                    onClick={() => downloadLearnerDocuments(app)}
                                >
                                    {downloadingCode === app.learnerCode ? (
                                        '...'
                                    ) : (
                                        <>
                                            <FontAwesomeIcon icon={faDownload} className="me-1" />
                                            Docs
                                        </>
                                    )}
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="pagination-controls">
                <button
                    onClick={() => handlePageChange('prev')}
                    disabled={currentPage === 0}
                >
                    Previous
                </button>
                <span>Page {currentPage + 1} of {totalPages}</span>
                <button
                    onClick={() => handlePageChange('next')}
                    disabled={currentPage >= totalPages - 1}
                >
                    Next
                </button>
            </div>
            <Modal returnFocusAfterClose={focusAfterClose} isOpen={open} centered >
                <ModalHeader toggle={closeLearnerModal}> Add Learner Details {learnerDetails.candidateCode}</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={6}>Learner Code</Col>
                        <Col md={6}><input name="learnerCode" onChange={(e) => handleLearnerDetailsChange(e)} /></Col>
                    </Row><br />
                    <Row>
                        <Col md={6}>Username</Col>
                        <Col md={6}><input name="uname" onChange={(e) => handleLearnerDetailsChange(e)} /></Col>
                    </Row><br />
                    <Row>
                        <Col md={6}>Password</Col>
                        <Col md={6}><input type="password" name="pwd" id="pwd" onChange={(e) => handleLearnerDetailsChange(e)} /></Col>
                    </Row><br />
                    <Row>
                        <Col md={6}>Re-enter Password</Col>
                        <Col md={6}><input type="password" name="pwd2" id="pwd2" onChange={(e) => handleLearnerDetailsChange(e)} /></Col>
                    </Row>
                </ModalBody>
                <ModalFooter>

                    <Button color="success" type="button" onClick={validateLearnerDetails}>  Submit  </Button>
                    <Button color="primary" onClick={closeLearnerModal}>  Close  </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default LearnerDetails;
